__webpack_require__.p = "/tuesday-homework/";